module.exports = __webpack_public_path__ + "img/portfolio-08.59a6821a.jpg";